// extracted by mini-css-extract-plugin
module.exports = {"required":"InputLabel_required__GQ2fC","label":"InputLabel_label__FtIQ8","regular":"InputLabel_regular__D5G7E","light":"InputLabel_light__S20ke"};